import React from 'react';
import { Outlet } from 'react-router-dom';
import { Layout, Typography, Breadcrumb } from 'antd';
import { HomeOutlined, UserAddOutlined } from '@ant-design/icons';
import '../styles/onboarding.css';

const { Content } = Layout;
const { Title } = Typography;

const CustomerOnboardingView: React.FC = () => {
  return (
    <Layout className="customer-onboarding-layout">
      <Content className="onboarding-content">
        
        <div className="onboarding-container">
          <Outlet />
        </div>
      </Content>
    </Layout>
  );
};

export default CustomerOnboardingView;
